import { CreateOrUpdateBaseService } from "../../../../common/services/createOrUpdateBase.service";
import { services } from "../../../../constants/services";

export class CreateOrUpdateUploadAvatarService extends CreateOrUpdateBaseService<any, any> {
  url = `${services.files}/upload-avatar`;
  isFormData = true;
}
